import { render, staticRenderFns } from "./TotalCase.vue?vue&type=template&id=6531b3a7"
import script from "./TotalCase.vue?vue&type=script&lang=js"
export * from "./TotalCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports